// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g1fk","left":"styles_left__1hbay"};